/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import ProgramStep from "@shared/Program/ProgramStep/ProgramStep";
import {StepType, StepVisibility} from "@shared/Program/ProgramStep/helpers/ProgramStepEnums";
import {Type} from "class-transformer";



export default class NoteProgramStep extends ProgramStep{

	constructor(name: string = "", description: string = "", subStepList: ProgramStep[] = []) {
		super(name, description, subStepList, StepType.NOTE);
	}

	static createPrivateNote(){
		let note = new NoteProgramStep()
		note.stepVisibility = StepVisibility.PRIVATE
		return note
	}

}



